import { Parser } from '~/api';
import RequestService from './request';

class SsoFailuresService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/settings/sso-failures', req).then(Parser.parse);
    }
}

export default new SsoFailuresService();
